export default {
  skip_to_main_content: 'الانتقال إلى المحتوى الرئيسي',
  show_system_messages: 'إظهار رسائل النظام',
  dont_show_system_messages: 'إخفاء رسائل النظام',
  logged_in: 'المستأجر مصدق عليه',
  logged_out: 'مستخدم مجهول',
  button_tooltip_switch_locale: 'تبديل اللغة',
  button_tooltip_activate_voice_recognition: 'تنشيط التعرف على الصوت',
  date_input: 'اختر التاريخ',
  choose_two_dates: 'الرجاء تحديد تاريخين',
  date_range: 'نطاق الموعد',
  from: 'من',
  to: 'ل',
  avatar: 'Avatar',
  exit: 'خروج',
  new: 'جديد',
  back: 'رجوع',
  address: 'عنوان',
  suggestions: 'اقتراحات',
  senton: 'تم الإرسال في',
  message_placeholder: 'أدخل رسالتك هنا ...',
  message_aria: 'أدخل رسالتك هنا',
  upload_in_progress: 'جاري التحميل...',
  comment_placeholder: 'أدخل التعليق هنا',
  message_button_label: 'إرسال',
  please_confirm: 'الرجاء التأكيد',
  no: 'لا',
  yes: 'نعم',
  modal_delete_session: 'حذف الجلسة',
  modal_delete_session_notification:
    'إذا أغلقت النافذة، سيتم أيضًا حذف جلستك.<br>هل أنت بخير مع ذلك؟',
  template_contact_time: 'متى يمكننا الاتصال بك؟',
  template_pause:
    'تم إيقاف جلستك مؤقتًا. سيهتم أحد موظفي الدعم لدينا بطلبك قريبًا.',
  template_continue_after_pause:
    'لقد استمرت جلستك. يمكنك الآن متابعة الكتابة باستخدام برنامج الدردشة الآلي الخاص بنا.',
  choose_date: 'الرجاء اختيار تاريخ',
  button_apply: 'تطبيق',
  button_cancel: 'إلغاء',
  none: 'لا شيء',
  book_appointment: 'حجز موعد',
  address_input: 'إدخال العنوان',
  data_processing: 'معالجة البيانات',
  privacy_policy: 'سياسة الخصوصية',
  data_processing_notification_before_link:
    'لاستخدام خدمة الدردشة هذه، من الضروري أن تقبل ',
  data_processing_notification_after_link: '.',
  button_accept: 'قبول',
  select_date: 'حدد التاريخ',
  rate_conversation: 'كيف تقيم هذه المحادثة؟',
  new_ticket_question: 'هل هناك أي شيء آخر يمكنني مساعدتك به؟',
  thank_you: 'شكرا لدعمكم. تساعدني ملاحظاتك على تحسين نفسي باستمرار.',
  goodbye: 'وداعا.',
  start_new: 'بدء محادثة جديدة',
  operator_entered_the_chat: 'دخل المشغل في الدردشة',
  operator_left_the_chat: 'غادر المشغل الدردشة',
  bg_image: process.env.VUE_APP_EN_BG,
  expand_quickreplies: 'المزيد',
  collapse_quickreplies: 'أقل',
  login: 'دخول',
  logout: 'تسجيل الخروج',
  close: 'إغلاق',
  messenger_text: 'هل لديك سؤال؟ نحن سعداء لمساعدتك!',
  chat_bot: 'روبوت الدردشة',
  live_bot: 'الدردشة الحية',
  maximize: 'تعظيم',
  minimize: 'تصغير',
  upload_file: 'إسقاط ملف للتحميل هنا',
  upload_file_or: 'أو',
  Upload_file_select: 'إضافة ملفات',
  upload_file_text: 'إسقاط ملف للتحميل',
  show_attachments: 'إظهار المرفقات',
  hide_attachments: 'إخفاء المرفقات',
  tooBig: 'الملف كبير جدًا',
  tooSmall: 'الملف صغير جدًا',
  invalidFileTypeCopilot:
    'نوع ملف غير صالح. حاليًا، يتم دعم أنواع الملفات .png، .jpg، .jpeg، .gif فقط.',
  tooManyFiles: 'يرجى تحميل 10 ملفات كحد أقصى في المرة الواحدة',
  uploadError: 'فشل التحميل. يرجى المحاولة مرة أخرى.',
  maxDocumentsReached: 'تم الوصول إلى الحد الأقصى لعدد المستندات (10) لهذه المحادثة',
  chatProtocol: 'بروتوكول الدردشة',
  showMore: 'شاهد المزيد',
  showLess: 'عرض أقل',
  uploadTooltip: 'رفع ملف',
  uploadFilesTooltip: 'تحميل الملفات',
  pdfDownloadTooltip: 'تنزيل المحادثة',
  feedbackDescription: 'اقتراحات لنا',
  feedbackPlaceholder: 'أدخل الرسالة هنا...',
  feedbackInfoPlaceholder: 'لا تتردد في إضافة تفاصيل محددة...',
  feedbackSubtitle: {
    description: 'هنا يمكنك أن ترسل إلينا اقتراحات عامة ومقترحات وطلبات.',
    note: 'يرجى ملاحظة أننا لا نستطيع الرد عليهم.',
    hint:
      'يمكن وصف جميع المخاوف الأخرى التي تتعلق على وجه التحديد بإيجارك أو البحث عن شقة لنا في الدردشة.'
  },
  sendFeedback: 'يرسل',
  giveFeedback: 'اقتراحات لنا',
  feedbackSubmittedSuccessfully: 'تم إرسال ملاحظاتك بنجاح',
  character_limit: 'أحرف',
  page: 'ص.',
  factually_incorrect: 'غير صحيحة حقيقيًا',
  not_following_instructions: 'لم يتبع التعليمات بشكل كامل',
  info_not_in_document: 'لم يتم العثور على المعلومات المطلوبة في المستند',
  inappropriate_or_offensive: 'المحتوى غير مناسب أو مسيء',
  irrelevant: 'غير ذات صلة',
  not_fitting_topic: 'غير مناسب للموضوع',
  confusing_information: 'معلومات مربكة',
  ignored_important_parts_of_document: 'تجاهل أجزاء مهمة من المستند',
  interpreted_document_wrong: 'تفسير المستند بشكل خاطئ',
  answer_to_generic: 'الرد على شكل عام',
  sources_incorrect: 'المصادر غير موثوقة أو تم الاقتباس منها بشكل خاطئ',
  why_not_helpful: 'لماذا لم يكن ذلك مفيدًا؟',
  thank_you_feedback: 'شكرًا لك على ملاحظاتك!',
  provide_feedback: 'تقديم ملاحظات حول الإجابة',
  not_helpful: 'غير مفيد',
  helpful: 'مفيد',
  regenerate_message: 'إعادة إنشاء',
  copy_message: 'نسخ',
  copied_message: 'تم النسخ!',
  copy_table_csv: 'نسخ الجدول',
  download_table_csv: 'تحميل CSV',
  expand_table: 'فتح الجدول',
  print: 'طباعة',
  original_answer: 'الإجابة الأصلية',
  regenerated_answer: 'الإجابة المعاد إنشاؤها',
  thinking_message: 'أفكر...',
  file_path: 'مسار الملف: ',
  new_messages: 'رسائل جديدة',
  previous_message: 'الرسالة السابقة',
  next_message: 'الرسالة التالية',
  clear_input: 'مسح الإدخال',
  open_feedback: 'فتح الملاحظات',
  file_upload: 'تحميل الملف',
  expand_quickreplies_aria: 'إظهار المزيد من الأزرار',
  button_tooltip_switch_locale_german: 'تغيير اللغة إلى الألمانية',
  button_tooltip_switch_locale_french: 'تغيير اللغة إلى الفرنسية',
  button_tooltip_switch_locale_dutch: 'تغيير اللغة إلى الهولندية',
  button_tooltip_switch_locale_turkish: 'تغيير اللغة إلى التركية',
  button_tooltip_switch_locale_russian: 'تغيير اللغة إلى الروسية',
  button_tooltip_switch_locale_swedish: 'تغيير اللغة إلى السويدية',
  button_tooltip_switch_locale_ukranian: 'تغيير اللغة إلى الأوكرانية',
  button_tooltip_switch_locale_spanish: 'تغيير اللغة إلى الإسبانية',
  button_tooltip_switch_locale_polish: 'تغيير اللغة إلى البولندية',
  button_tooltip_switch_locale_arabic: 'تغيير اللغة إلى العربية',
  button_tooltip_switch_locale_italian: 'تغيير اللغة إلى الإيطالية',
  button_tooltip_switch_locale_english: 'تغيير اللغة إلى الإنجليزية',
  message_from_you: 'أنت تقول',
  message_from_bot: 'الروبوت يقول',
  message_from_operator: 'الوكيل يقول',
  new_message_from_bot: 'الروبوت يقول',
  empty_message_received: 'تم استلام رسالة فارغة',
  open_quick_actions: 'فتح الإجراءات السريعة',
  quick_actions: 'الإجراءات السريعة',
  quick_actions_search_hint: '...أو استمر في الكتابة للحصول على اقتراحات',
  quick_actions_no_results: 'لم يتم العثور على نتائج'
}
